// extracted by mini-css-extract-plugin
export default {"headerLayout":"header_headerLayout__oMcBi","logo":"header_logo__esDFp","headerTitle":"header_headerTitle__88wDF","shape":"header_shape__x-7Yw"};